<template>
  <div id="app">
    <div class="main-header">
      <div class="main-header-logo" @click="goHome">
        <img
          src="./apex-ui-logo.png"
          alt="logo"
        >
      </div>
      <div class="main-header-title" @click="goHome">Apex-UI 组件库</div>
      <ul class="main-header-nav">
        <li>
          <router-link to="/introduction">组件</router-link>
        </li>
        <li>
          <router-link to="/changelog">更新记录</router-link>
        </li>
      </ul>
    </div>

    <div class="main-content">
      <div v-show="showNav" class="main-content-left">
        <ul>
          <li v-for="(item, index) in navList" :key="index">
            <router-link :to="item.path">{{ item.title }}</router-link>
          </li>
        </ul>
      </div>
      <div class="main-content-right">
        <el-backtop target=".main-content-right" />
        <router-view v-show="showNav" class="markdown" />
        <div v-show="!showNav" class="changelog-container">
          <div class="heading">更新日志</div>
          <ul ref="timeline" class="timeline" />
        </div>
        <changelog ref="changeLog" />
      </div>
    </div>
  </div>
</template>

<script>
import changelog from './pages/changelog.md'

export default {
  name: 'App',
  components: {
    changelog
  },
  data() {
    return {
      navList: [],
      showNav: true
    }
  },
  watch: {
    '$route'(to) {
      // 修复滚动条到页面最顶部
      document.querySelector('.main-content-right').scrollTop = 0
      if (to.name === 'changelog') {
        this.showNav = false
      } else {
        this.showNav = true
      }
    }
  },
  created() {
    const routes = this.$router.options.routes
    this.navList = routes.filter(item => item.meta && item.meta.title).map(item => {
      return {
        path: item.path,
        title: item.meta.title
      }
    })
  },
  mounted() {
    this.initChangelog()
  },
  methods: {
    goHome() {
      this.$router.push('/introduction')
    },
    initChangelog() {
      const changeLog = this.$refs.changeLog
      const changeLogNodes = changeLog.$el.children
      let release = changeLogNodes[1].textContent.trim()
      let fragments = `<li><h3>${release}</h3>`

      for (let len = changeLogNodes.length, i = 2; i < len; i++) {
        const node = changeLogNodes[i]
        if (node.tagName !== 'H3') {
          fragments += changeLogNodes[i].outerHTML
        } else {
          release = changeLogNodes[i].textContent.trim()
          fragments += `</li><li><h3>${release}</h3>`
        }
      }
      this.$refs.timeline.innerHTML = `${fragments}</li>`

      changeLog.$el.remove()
    }
  }
}
</script>

<style lang="scss">
@import 'style/common.scss';
@import 'style/md.scss';

</style>
